// Metrik değer biçimlendirme + görsel yardımcılar (panel).

const TR = (lang) => lang !== 'en';

// Büyük sayıyı kısaltır: 1.234.567 -> "1,23 Mn" / "1.23M"
export function compact(n, lang = 'tr') {
  const abs = Math.abs(n);
  const tr = TR(lang);
  const sfx = tr
    ? { q: ' Kat', b: ' Mr', m: ' Mn', k: ' B' }
    : { q: 'T', b: 'B', m: 'M', k: 'K' };
  const f = (x) => {
    const a = Math.abs(x);
    const s = x.toFixed(a < 10 ? 2 : a < 100 ? 1 : 0);
    return tr ? s.replace('.', ',') : s;
  };
  if (abs >= 1e12) return f(n / 1e12) + sfx.q;
  if (abs >= 1e9) return f(n / 1e9) + sfx.b;
  if (abs >= 1e6) return f(n / 1e6) + sfx.m;
  if (abs >= 1e4) return f(n / 1e3) + sfx.k;
  return Math.round(n).toLocaleString(tr ? 'tr-TR' : 'en-US');
}

// Metrik birimine göre gösterim değeri.
export function formatValue(value, unit, lang = 'tr') {
  const tr = TR(lang);
  const v = Number(value) || 0;
  if (unit === 'percent') return (tr ? '%' + compact(v, lang) : compact(v, lang) + '%');
  if (unit === 'gold') return compact(v, lang);
  if (unit === 'count_per_hour') return compact(v, lang) + (tr ? '/sa' : '/h');
  return compact(v, lang);
}

// Trend yüzdesi -> {text, tone} (betterWhen'e göre yeşil/kırmızı)
export function deltaTone(delta, betterWhen) {
  if (delta == null || !isFinite(delta)) return { text: '—', tone: 'flat' };
  const sign = delta > 0 ? '+' : '';
  const text = `${sign}${delta}%`;
  if (Math.abs(delta) < 1.5 || betterWhen === 'neutral') return { text, tone: 'flat' };
  const good = betterWhen === 'up' ? delta > 0 : delta < 0;
  return { text, tone: good ? 'up' : 'down' };
}

export const STATUS_TONE = { ok: 'ok', warn: 'warn', crit: 'crit' };

// Sağlık skoru etiketi
export function healthLabelKey(label) {
  return `health.label_${label || 'ok'}`;
}
